const CustomerData = async (data) => {
  if (!window.eS) return

  const generalInfo = {}
  const customerData = {}
  if (window.phone) generalInfo.user_phone = window.phone
  if (window.email) generalInfo.user_email = window.email
  if (data.user_phone || window.phone) {
    generalInfo.externalCustomerId = data.user_phone || window.phone
    customerData.externalCustomerId = generalInfo.externalCustomerId
  }

  window.eS("sendEvent", "CustomerData", {
    CustomerData: {
      // 'externalCustomerId': '1234509876',
      // 'user_email': 'example@email.com',
      // 'user_name': 'Johny',
      // 'user_client_id': '123',
      // 'user_card_id': '321',
      // 'user_phone': '3801111111111',
      // 'user_city': 'Gdańsk',
      // 'user_tags_gender': 'male',
      ...data,
      ...customerData,
    },
    GeneralInfo: {
      ...generalInfo,
    },
  })
}
export default CustomerData
